var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsMailEdit01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:mail-edit-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 6L8.913 9.917C11.462 11.361 12.538 11.361 15.087 9.917L22 6",
    stroke: "#243642",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.9948 10.5276C21.9298 7.46063 21.8968 5.92763 20.7648 4.79063C19.6338 3.65463 18.0588 3.61563 14.9078 3.53663C12.9731 3.48779 11.0375 3.48779 9.1028 3.53663C5.9528 3.61563 4.3768 3.65463 3.2458 4.79063C2.1148 5.92663 2.0808 7.46063 2.0158 10.5276C1.99473 11.5119 1.99473 12.4964 2.0158 13.4806C2.0808 16.5486 2.1138 18.0816 3.2458 19.2176C4.3778 20.3536 5.9528 20.3936 9.1028 20.4726C9.5708 20.484 10.0381 20.493 10.5048 20.4996M20.8518 13.9396L21.5448 14.6316C21.826 14.9129 21.984 15.2944 21.984 15.6921C21.984 16.0899 21.826 16.4713 21.5448 16.7526L17.9168 20.4486C17.6314 20.7337 17.2664 20.9258 16.8698 20.9996L14.6218 21.4876C14.5402 21.5053 14.4554 21.5023 14.3752 21.4788C14.295 21.4553 14.222 21.4121 14.1628 21.3531C14.1037 21.2942 14.0602 21.2213 14.0364 21.1412C14.0127 21.0611 14.0094 20.9763 14.0268 20.8946L14.5058 18.6596C14.5798 18.2626 14.7718 17.8976 15.0568 17.6126L18.7308 13.9386C19.0121 13.6574 19.3936 13.4995 19.7913 13.4995C20.189 13.4995 20.5705 13.6584 20.8518 13.9396Z",
    stroke: "#243642",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsMailEdit01);
export default __webpack_public_path__ + "static/media/hugeicons_mail-edit-01.c3c369fc9cc6b12909059741e454b959.svg";
export { ForwardRef as ReactComponent };